const addToBottomBanner = (index) => {
  setTimeout(() => {
    const swatches = document.querySelectorAll(`[data-element-id=image-swatches-${index + 1}] .gpo-swatches input[type=checkbox]`);
  
    if (swatches && swatches.length) {
      const checkedSwatches = [].slice.call(swatches).filter(swatch => swatch.checked);
      let banner = document.querySelector(".sweet-arture-custom-bottom-banner");
      let bannerInner = document.querySelector(".sweet-arture-custom-bottom-banner__inner");

      if (!banner && checkedSwatches.length) {
        banner = document.createElement("div");
        banner.classList.add("sweet-arture-custom-bottom-banner");
        
        bannerInner = document.createElement("div");
        bannerInner.classList.add("sweet-arture-custom-bottom-banner__inner");
        bannerInner.textContent = checkedSwatches.map(swatch => swatch.value).join(", ");

        banner.appendChild(bannerInner);
        document.body.appendChild(banner);
      } else if (checkedSwatches.length) {
        bannerInner.textContent = checkedSwatches.map(swatch => swatch.value).join(", ");
      } else {
        banner.parentElement.removeChild(banner);
      }
    }
  }, 0);
};

const addSwatchEvents = (index) => {
  const swatches = document.querySelectorAll(".gpo-swatches input[type=checkbox]");

  swatches.forEach(swatch => {
    swatch.addEventListener("input", (event) => {
        event.stopPropagation();
        addToBottomBanner(index);
    });
  });
}; 

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const radios = document.querySelectorAll(".gpo-swatches.buttons > input[type=radio]");
  
    radios.forEach((radio, index) => {
      radio.addEventListener("input", () => {
          addSwatchEvents(index);
      });
    });
  }, 1000);
});